/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type MenuCollectionProductFragment = {
  readonly __typename?: 'Product';
  readonly id: string;
  readonly slug: string;
  readonly name: string;
  readonly description: string;
  readonly calories: number;
  readonly cost: number;
  readonly restaurantId: string;
  readonly label: {
    readonly __typename?: 'ProductLabel';
    readonly id: string;
    readonly name: string;
  } | null;
  readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  readonly dietaryProperties: ReadonlyArray<{
    readonly __typename?: 'DietaryProperty';
    readonly id: string;
    readonly name: Types.DietaryPropertyKind;
  }>;
  readonly ingredients: ReadonlyArray<{
    readonly __typename?: 'Ingredient';
    readonly id: string;
    readonly name: string;
  }>;
};

export type MenuCollectionQueryVariables = Types.Exact<{
  collectionId: Types.Scalars['ID'];
}>;

export type MenuCollectionQuery = {
  readonly __typename?: 'Query';
  readonly menuCollection: {
    readonly __typename?: 'MenuCollection';
    readonly id: string;
    readonly color: string;
    readonly primaryImageUrl: string;
    readonly primaryTitle: string;
    readonly primaryDescription: string;
    readonly products: ReadonlyArray<{
      readonly __typename?: 'Product';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly description: string;
      readonly calories: number;
      readonly cost: number;
      readonly restaurantId: string;
      readonly label: {
        readonly __typename?: 'ProductLabel';
        readonly id: string;
        readonly name: string;
      } | null;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      readonly dietaryProperties: ReadonlyArray<{
        readonly __typename?: 'DietaryProperty';
        readonly id: string;
        readonly name: Types.DietaryPropertyKind;
      }>;
      readonly ingredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
      }>;
    }>;
  };
};

export const menuCollectionQueryMock: ExecutionResult<MenuCollectionQuery> = {
  data: {
    menuCollection: {
      id: 'e509e6ea-9fee-442a-9962-587ce7190430',
      color: 'Hello World',
      primaryImageUrl: 'Hello World',
      primaryTitle: 'Hello World',
      primaryDescription: 'Hello World',
      products: [
        {
          id: 'da7a7163-ba7e-4da9-ae8a-185e3da00a9a',
          slug: 'Hello World',
          name: 'Hello World',
          description: 'Hello World',
          calories: -48,
          cost: -2,
          restaurantId: '534319d0-8060-4b59-aa25-0f9c4016b1bd',
          label: {
            id: '634cb273-b7f9-4f18-9030-f1b1f2c49f5f',
            name: 'Hello World',
          },
          asset: { url: 'Hello World' },
          dietaryProperties: [
            { id: '7994ccdc-ab38-4b74-85af-be88532ede7a', name: 'DAIRY' },
            { id: '1daa933e-0e09-45a7-b48f-0bb560d0180d', name: 'DAIRY' },
            { id: '39ca0c05-20a3-452a-8a65-41b5bc5d089f', name: 'DAIRY' },
          ],
          ingredients: [
            { id: '2e921d91-bfdf-4bab-938f-df8eb150587b', name: 'Hello World' },
            { id: '384c4829-9be5-411f-9b1e-39b6d74afbe5', name: 'Hello World' },
          ],
        },
        {
          id: '2f8a3a6f-32f0-4eda-af12-2810af291521',
          slug: 'Hello World',
          name: 'Hello World',
          description: 'Hello World',
          calories: 40,
          cost: -71,
          restaurantId: '7f2badd9-c8f9-46f0-90ca-15396429788b',
          label: {
            id: '394138d5-0049-434e-880a-d7fd62514dd9',
            name: 'Hello World',
          },
          asset: { url: 'Hello World' },
          dietaryProperties: [
            { id: 'f36b41c2-3d4c-44b9-acaa-8622a517d3cb', name: 'DAIRY' },
          ],
          ingredients: [
            { id: '3f05167a-358d-4451-b931-3663db9eb2f5', name: 'Hello World' },
            { id: '17f534a2-7f5a-4cfb-9a03-bfaf7e27a59a', name: 'Hello World' },
            { id: '381e6485-5fe3-4c24-b0d5-f38aff27422c', name: 'Hello World' },
          ],
        },
      ],
    },
  },
};
export const MenuCollectionProductFragmentDoc = gql`
  fragment MenuCollectionProduct on Product {
    id
    slug
    name
    description
    calories
    cost
    restaurantId
    label {
      id
      name
    }
    asset {
      url
    }
    dietaryProperties {
      id
      name
    }
    ingredients {
      id
      name
    }
  }
`;
export const MenuCollectionDocument = gql`
  query MenuCollection($collectionId: ID!) {
    menuCollection(id: $collectionId) {
      id
      color
      primaryImageUrl
      primaryTitle
      primaryDescription
      products {
        ...MenuCollectionProduct
      }
    }
  }
  ${MenuCollectionProductFragmentDoc}
`;

export function useMenuCollectionQuery(
  options: Omit<Urql.UseQueryArgs<MenuCollectionQueryVariables>, 'query'>,
) {
  return Urql.useQuery<MenuCollectionQuery, MenuCollectionQueryVariables>({
    query: MenuCollectionDocument,
    ...options,
  });
}
